import _defineProperty from "/var/jenkins_home/workspace/tingle.a6c135a2-37b2-4c6f-8c3d-f6d4497fd2e3/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _optionsMap;

import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { IconChevronRight, IconPlay, Type } from '@spotify-internal/encore-web';
import { Supertext, Link } from '../../../ui';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { kleinBlue, screenMdMax, screenXsMax, spacer8, spacer16, spacer24, spacer32, heading4FontWeight, body3FontSize, cta1FontWeight, body2FontSize } from '@spotify-internal/encore-foundation';
import { hidden } from '../../util';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ItemWrapper = styled(Link).withConfig({
  displayName: "FAQItem__ItemWrapper",
  componentId: "nnaw7s-0"
})(["background:", ";color:", ";width:calc(25% - ", ");&:hover:not(:focus):not(:disabled){color:", ";}@media (max-width:", "){margin:", ";width:calc(50% - ", ");}@media (max-width:", "){width:calc(100% - ", ");margin:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.box.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.link.color;
}, spacer16, function (_ref3) {
  var theme = _ref3.theme;
  return hexToRgba(theme.link.color, 0.75);
}, screenMdMax, function (_ref4) {
  var compact = _ref4.compact;
  return compact ? '0' : "0 ".concat(spacer16, " ").concat(spacer16, " 0");
}, spacer24, screenXsMax, spacer16, function (_ref5) {
  var compact = _ref5.compact;
  return compact ? '0' : "0 0 ".concat(spacer16, " 0");
});
var TextWrapper = styled.div.withConfig({
  displayName: "FAQItem__TextWrapper",
  componentId: "nnaw7s-1"
})(["width:calc(100% - ", ");@media (max-width:", "){width:100%;}@media (max-width:", "){width:100%;}"], spacer16, screenMdMax, screenXsMax);
var Title = styled(Type.h4).attrs({
  variant: Type.heading4
}).withConfig({
  displayName: "FAQItem__Title",
  componentId: "nnaw7s-2"
})(["font-weight:", ";padding-bottom:", ";@media (max-width:", "){width:90%;font-weight:", ";}"], function (_ref6) {
  var bold = _ref6.bold;
  return bold ? cta1FontWeight : heading4FontWeight;
}, function (_ref7) {
  var compact = _ref7.compact;
  return compact ? spacer8 : spacer16;
}, screenXsMax, heading4FontWeight);
var TitleContainer = styled.div.withConfig({
  displayName: "FAQItem__TitleContainer",
  componentId: "nnaw7s-3"
})(["display:flex;flex-direction:row;padding-bottom:", ";@media (max-width:", "){align-items:center;justify-content:space-between;}"], function (_ref8) {
  var largeBottomPadding = _ref8.largeBottomPadding;
  return largeBottomPadding ? spacer16 : '';
}, screenXsMax);
var StyledSupertext = styled(Supertext).withConfig({
  displayName: "FAQItem__StyledSupertext",
  componentId: "nnaw7s-4"
})(["font-size:", ";padding-bottom:", ";color:", ";@media (max-width:", "){", "}"], function (_ref9) {
  var large = _ref9.large,
      xl = _ref9.xl;

  if (xl) {
    return spacer32;
  } else if (large) {
    return body2FontSize;
  }

  return body3FontSize;
}, function (_ref10) {
  var large = _ref10.large;
  return large ? spacer16 : '0';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.help.grayBox.text;
}, screenXsMax, hidden);
var StyledChevronRightIcon = styled(IconChevronRight).withConfig({
  displayName: "FAQItem__StyledChevronRightIcon",
  componentId: "nnaw7s-5"
})(["display:none;@media (max-width:", "){display:flex;align-self:center;}"], screenXsMax);
var PlayButton = styled(IconPlay).withConfig({
  displayName: "FAQItem__PlayButton",
  componentId: "nnaw7s-6"
})(["height:", ";width:", ";padding-right:2px;color:", ";transform:translateY(2px);"], spacer16, spacer16, kleinBlue);

var showPlayButton = function showPlayButton(hit, variant) {
  return variant === 'related' && (hit.contentType === 'video' || hit.contentType === 'videoPage');
};

var TRACK_CAT = 'helpFAQ';
export var Variant;

(function (Variant) {
  Variant["SPEED_DIAL"] = "speedDial";
  Variant["RELATED"] = "related";
})(Variant || (Variant = {}));

var optionsMap = (_optionsMap = {}, _defineProperty(_optionsMap, Variant.SPEED_DIAL, {
  boldTitle: true,
  largeSuperText: true,
  compact: false
}), _defineProperty(_optionsMap, Variant.RELATED, {
  boldTitle: false,
  largeSuperText: false,
  compact: true
}), _optionsMap);
export var FAQItem = function FAQItem(_ref12) {
  var hit = _ref12.hit,
      variant = _ref12.variant;
  var options = optionsMap[variant];
  var t = useT();
  var router = useRouter();
  var contentTypeLabels = {
    videoPage: t('FRODOR_51e9b5', 'Video', ''),
    articlePage: t('FRODOR_ae3cce', 'Article', ''),
    default: t('FRODOR_2b4d70', 'Resource', ''),
    faq: t('FRODOR_047e76', 'FAQ', '')
  }; // moved logic from content.ts for translation purposes

  if (hit.contentType === 'articlePage' || hit.contentType === 'landingPage' || hit.contentType === 'videoPage') {
    hit.label = contentTypeLabels[hit.contentType] || contentTypeLabels.default;
  } else if (hit.contentType === 'faq' && !hit.label) {
    hit.label = contentTypeLabels.faq;
  }

  return /*#__PURE__*/_jsx(ItemWrapper, {
    "data-testid": "faq-item",
    href: hit.url,
    track: [TRACK_CAT, 'FAQ Link'],
    compact: options.compact,
    children: hit.label && hit.title && /*#__PURE__*/_jsxs(TextWrapper, {
      children: [/*#__PURE__*/_jsx(StyledSupertext, {
        jumbo: variant === 'related',
        eyebrowPadding: variant === 'related',
        large: options.largeSuperText,
        children: router && router.query && router.query._lqa === 'showFAQItemDefaults' ? "".concat(contentTypeLabels.videoPage, " ").concat(contentTypeLabels.articlePage, " ").concat(contentTypeLabels.default, " ").concat(contentTypeLabels.faq) : "".concat(hit.label)
      }), /*#__PURE__*/_jsxs(TitleContainer, {
        largeBottomPadding: variant === 'related',
        children: [/*#__PURE__*/_jsxs(Title, {
          compact: options.compact,
          bold: options.boldTitle,
          children: [showPlayButton(hit, variant) && /*#__PURE__*/_jsx(PlayButton, {
            "data-testid": "play-button",
            "aria-hidden": true
          }), hit.title]
        }), /*#__PURE__*/_jsx(StyledChevronRightIcon, {
          iconSize: 16
        })]
      })]
    })
  });
};